import { API_URL } from '../api';
import { uploadJson } from './surveyorUpload';

export async function getUploadRecovery(eventId, token, { processId, intent, additionalId, summary = false, signal } = {}) {
  const query = new URLSearchParams();
  if (processId != null) query.set('process_id', String(processId));
  if (intent) query.set('intent', intent);
  if (additionalId != null) query.set('additional_id', String(additionalId));
  if (summary) query.set('summary', '1');
  const encoded = query.toString();
  const suffix = encoded ? `?${encoded}` : '';
  const result = await uploadJson(API_URL, `events/${eventId}/process-status/${suffix}`, { token, signal });
  if (result?.code >= 400 || typeof result?.has_process !== 'boolean') {
    throw Object.assign(new Error(result?.message || result?.detail || 'Не удалось проверить предыдущую загрузку. Повторите проверку.'), { status: Number(result?.code || 0) });
  }
  return result;
}

export async function getActiveUploadRecovery(token, signal) {
  const result = await uploadJson(API_URL, 'processes/active/', { token, signal });
  if (result?.code >= 400 || !Array.isArray(result?.processes)) {
    throw Object.assign(new Error(result?.message || result?.detail || 'Не удалось проверить список передач.'), { status: Number(result?.code || 0) });
  }
  return result;
}

export async function cancelInterruptedUpload(eventId, process, token, signal) {
  const result = await uploadJson(API_URL, `events/${eventId}/upload-recovery/cancel/`, {
    token, signal, data: { process_id: process.process_id, revision: process.revision, confirmed: true },
  });
  if (result?.status !== 'ok' || result?.code >= 400) throw new Error(result?.message || result?.detail || 'Не удалось остановить передачу. Обновите статус.');
  return result;
}

// The server supplies only local route descriptors; never follow an arbitrary
// URL from a stale response or pass account credentials to another origin.
export function uploadResumePath(value, eventId) {
  try {
    const url = new URL(value, 'https://planium.invalid');
    if (url.origin !== 'https://planium.invalid' || !/^\/surveyor\/(close|supplement)\/\d+$/.test(url.pathname)
      || url.searchParams.get('event') !== String(eventId) || url.hash) return null;
    return url.pathname + url.search;
  } catch { return null; }
}
